import { authEndpoints } from "@/constants";
import { axiosClient, setTokenHandler } from "@/services/axios-client";
import { transformApiUserHandler } from "@/services/shared";
import type { ApiUserType, LoginRequestType, LoginResponseType } from "@/types";

export const loginHandler = async ({
    email,
    password,
}: LoginRequestType): Promise<LoginResponseType> => {
    const response = await axiosClient.post<{
        token: string,
        token_type: string,
        user: ApiUserType,
    }>(
        authEndpoints.login,
        {
            email,
            password,
        },
    );

    setTokenHandler(response.data.token);

    return {
        token: response.data.token,
        tokenType: response.data.token_type,
        user: transformApiUserHandler(response.data.user),
    };
};
